var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVodIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49832 9.58801L17.0783 5.64036L16.4466 3.58757C16.2098 2.79804 15.3413 2.32432 14.4728 2.56118L3.81414 5.71931C3.0246 5.95617 2.55089 6.82465 2.78775 7.69314L3.49832 9.58801ZM3.49832 9.58801H17.7099V15.9043C17.7099 16.3231 17.5435 16.7247 17.2474 17.0208C16.9513 17.317 16.5496 17.4833 16.1308 17.4833H5.07739C4.65859 17.4833 4.25695 17.317 3.96082 17.0208C3.66469 16.7247 3.49832 16.3231 3.49832 15.9043V9.58801ZM6.02483 5.08768L8.47237 8.16686M10.9199 3.58757L13.3675 6.7457",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodIcon);
export default __webpack_public_path__ + "static/media/vodIcon.96928564ab42650759cade4319d90463.svg";
export { ForwardRef as ReactComponent };